module.exports = __webpack_public_path__ + "static/blindheim-f5b0b44286f95da7303827da3e27e6d8.jpeg";